import $ from "jquery";
import { assignNewUrl, newParamsObj } from "../listFilter.js";

$(".reusable__input-no-style").each((_, reusableItem) => {
  if ($(reusableItem).has(".clear__button")) {
    const curInput = $(reusableItem).find("input");
    const clearButton = curInput.parent().find(".clear__button");

    // Кнопка очистки
    clearButton.on("click", function () {
      curInput.val("");
      clearButton.hide();

      // Удаляем полностью поиск по имени
      delete newParamsObj["filter[*name]"];

      // Включаем все категории, если они есть
      if (Object.keys(window.allCategories || {}).length > 0) {
        newParamsObj["filter[category_id]"] = Object.keys(window.allCategories);
        // если мы на мастерских
        if (window.location.href.includes("workshops")) {
          newParamsObj["filter[category_ids]"] = Object.keys(
            window.allCategories
          );
          delete newParamsObj["filter[category_id]"];
        }
      }

      assignNewUrl(newParamsObj);
    });

    // При загрузке страницы показываем кнопку если в инпуте есть текст
    if (curInput.val().length > 0) {
      clearButton.show();
    }

    // Следим за вводом текста
    curInput.on("input", function () {
      if ($(this).val().length > 0) {
        clearButton.show();
      } else {
        clearButton.hide();
      }
    });
  }
});
